import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Vuetify imports
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

// The Vuetify build plugin imports only each page's components on demand.
const vuetify = createVuetify({
  theme: {
    defaultTheme: 'myCustomTheme',
    themes: {
      myCustomTheme: {
        dark: false,
        colors: {
          primary: '#4CAF50',
            secondary: '#FFC107',
            accent: '#9C27B0',
            error: '#f44336',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FB8C00',
          },
        },
      },
    },
  })
  

createApp(App).use(vuetify).use(router).mount('#app')
